import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IBuildList } from '../../shared/buildList';
import { BuildListService } from '../buildlist.service';

import * as xlsx from 'xlsx';
import { IWorkItem } from '../../shared/workItem';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-item-grid',
  templateUrl: './item-grid.component.html',
  styleUrls: ['./item-grid.component.css']
})
export class ItemGridComponent implements OnInit {

  //@Input() buildList: IBuildList;
  @Input() workItems: IWorkItem[];
  @Output() refresh = new EventEmitter();
  //@ViewChild('epltable') epltable: ElementRef;
  workItems$: Observable<IWorkItem[]>;
  filter = new FormControl('');

  constructor(private data: BuildListService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {

    this.workItems$ = this.filter.valueChanges.pipe(
      startWith(''),
      map(text => this.search(text))
    );
    //one bug having to do with notes column disappearing if you change it, then search something else
  }


  search(text: string): IWorkItem[] {
    //if (workitems == null) return;
    return this.workItems?.filter(workitem => {
      const term = text.toLowerCase();
      return workitem.areaPath.toLowerCase().includes(term)
        || workitem.iterationPath.toLowerCase().includes(term)
        || workitem.title.toLowerCase().includes(term);
    });
  }

  saveNotes(notes: string, id: string) {
    this.data.getBuildListItemById(id)
      .subscribe(item => {
        item.notes = notes;
        this.data.updateBuildListItem(id, item)
          .subscribe(result => {
            //do nothing?
          })
      })
      
  }

  toggleHidden(hidden: boolean, id: string) {
    this.data.getBuildListItemById(id)
      .subscribe(item => {
        item.isHidden = hidden;
        this.data.updateBuildListItem(id, item)
          .subscribe(result => {
            //do nothing?
          })
      })
  }

  refreshState(arg: any) {
      //this.data.refreshState(this.buildList.id)
          //.subscribe(result => {
              //this.buildList = result;
            this.refresh.emit(null);
          //})
      
    }

  removeWorkItem(id: string) {
      this.data.removeWorkItem(id)
          .subscribe(result => {
              this.workItems = this.workItems.filter(x => x.id != parseInt(id, 10))
          })
      this.refresh.emit(null);
  }

  exportToExcel() {
    //const ws: xlsx.WorkSheet = xlsx.utils.table_to_sheet(this.epltable.nativeElement);
    //const wb: xlsx.WorkBook = xlsx.utils.book_new();
    //xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    //xlsx.writeFile(wb, 'epltable.xlsx');
  }

}
